import { useState } from "react";
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
    

const FloatingButton = () => {
  const [showOptions, setShowOptions] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showDownloads, setShowDownloads] = useState(false);

  return (
    <>
      {/* Floating Button */}
      <div className="fixed bottom-24 right-6 z-50 flex flex-col items-end gap-2">
        {showOptions && (
          <div className="flex flex-col gap-2 mb-2">
            <button
              className="bg-white text-black border border-gray-300 rounded-xl px-4 py-2 shadow-md hover:bg-gray-100 transition"
              onClick={() => {
                setShowContactModal(true);
                setShowOptions(false);
              }}
            >
              Contact Us
            </button>
            <button
              className="bg-white text-black border border-gray-300 rounded-xl px-4 py-2 shadow-md hover:bg-gray-100 transition"
              onClick={() => {
                setShowDownloads(true);
                setShowOptions(false);
              }}
            >
              Downloadables
            </button>
          </div>
        )}

        <button
          className="bg-orange-600 hover:bg-blue-700 text-white px-6 py-3 rounded-full shadow-lg transition"
          onClick={() => setShowOptions(!showOptions)}
        >   <LiveHelpIcon/>
          Ask Me
        </button>
      </div>

      {/* Contact Modal */}
      {showContactModal && (
        <div className="fixed inset-0 z-40 bg-blur bg-opacity-40 backdrop-blur-sm flex items-center justify-center px-4">
          <div className="bg-white w-full max-w-md p-6 rounded-2xl shadow-xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">Contact Us</h2>
              <button onClick={() => setShowContactModal(false)}>&times;</button>
            </div>
            <form className="space-y-4">
              <input
                type="text"
                placeholder="Your Name"
                className="w-full border border-gray-300 rounded-lg p-2"
              />
              <input
                type="email"
                placeholder="Email"
                className="w-full border border-gray-300 rounded-lg p-2"
              />
              <input
                type="tel"
                placeholder="Mobile Number"
                className="w-full border border-gray-300 rounded-lg p-2"
              />
              <textarea
                placeholder="Your Message"
                rows="4"
                className="w-full border border-gray-300 rounded-lg p-2"
              />
              <button
                type="submit"
                className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Downloadables Modal */}
      {showDownloads && (
        <div className="fixed inset-0 z-40 bg-blur bg-opacity-40 backdrop-blur-sm flex items-center justify-center px-4">
          <div className="bg-white w-full max-w-md p-6 rounded-2xl shadow-xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">Downloadable Files</h2>
              <button onClick={() => setShowDownloads(false)}>&times;</button>
            </div>
            <ul className="space-y-2">
              <li>
                <a
                  href="/files/sample1.pdf"
                  download
                  className="text-blue-600 underline"
                >
                  Sample File 1
                </a>
              </li>
              <li>
                <a
                  href="/files/sample2.docx"
                  download
                  className="text-blue-600 underline"
                >
                  Sample File 2
                </a>
              </li>
              <li>
                <a
                  href="/files/sample3.zip"
                  download
                  className="text-blue-600 underline"
                >
                  Sample File 3
                </a>
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default FloatingButton;
